"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const datasetContext_1 = __importDefault(require("../context/dataset/datasetContext"));
const chartContext_1 = __importDefault(require("../context/chart/chartContext"));
const jsonpath_1 = __importDefault(require("jsonpath"));
const Input = ({ data, selectedDataset }) => {
    const datasetContext = (0, react_1.useContext)(datasetContext_1.default);
    const chartContext = (0, react_1.useContext)(chartContext_1.default);
    const { chartDataList, chartLabels, getChartsData, removeChartsDataByLabel } = chartContext;
    const { jsonDataByIdList, jsonDataCategory } = datasetContext;
    const [checked, setChecked] = (0, react_1.useState)(false);
    let chartDataListCopy = JSON.parse(JSON.stringify(chartDataList));
    const onChange = (event) => {
        if (!checked) {
            const label = event.target.getAttribute("name") || "";
            let length = jsonDataByIdList.length;
            let title = selectedDataset;
            for (let i = 0; i < length; i++) {
                let currentYear = parseInt(jsonDataByIdList[i].year);
                let jsonObjToSearch = jsonpath_1.default.query(JSON.parse(jsonDataByIdList[i].json_data), `$..["${selectedDataset}"]`);
                if (chartDataListCopy.length > 0) {
                    let foundElement = null;
                    // Search for Item with current Year
                    for (const element of chartDataListCopy) {
                        if (element.year === currentYear) {
                            foundElement = element;
                            break;
                        }
                    }
                    if (foundElement != null) {
                        foundElement.data.push(jsonpath_1.default.query(jsonObjToSearch, `$..["${label}"]`)[0]);
                    }
                    else {
                        chartDataListCopy.push({
                            year: currentYear,
                            data: [jsonpath_1.default.query(jsonObjToSearch, `$..["${label}"]`)[0]],
                        });
                    }
                }
                else {
                    chartDataListCopy.push({
                        year: currentYear,
                        data: [jsonpath_1.default.query(jsonObjToSearch, `$..["${label}"]`)[0]],
                    });
                }
            }
            getChartsData(title, label, chartDataListCopy, jsonDataCategory);
        }
        else {
            removeChartsDataByLabel(event.target.getAttribute("name") || "");
        }
        setChecked(!checked);
    };
    (0, react_1.useEffect)(() => {
        let currentChartLabel = null;
        for (const element of chartLabels) {
            if (element === data.label) {
                currentChartLabel = element;
                break;
            }
        }
        if (currentChartLabel != null) {
            setChecked(true);
        }
        else {
            setChecked(false);
        }
        chartDataListCopy = JSON.parse(JSON.stringify(chartDataList));
    }, [chartLabels]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { key: Math.random(), className: "form-check-input float-left\n                mr-2 h-4 w-4 cursor-pointer appearance-none\n                rounded-sm border border-gray-300 bg-[#ffffff]\n                bg-contain bg-center bg-no-repeat align-top transition\n                duration-200 checked:border-blue-600 checked:bg-blue-600\n                focus:outline-none", type: "checkbox", id: data.label, name: data.label, defaultChecked: checked, onChange: onChange }),
        react_1.default.createElement("label", { className: "flex cursor-pointer items-center h-12 p-3 pr-20 flex-1 ", htmlFor: data.label }, data.label.charAt(0).toUpperCase() + data.label.slice(1))));
};
exports.default = Input;
